export default __webpack_public_path__ + "static/ccpFzvmf-cf7a6a6108987f3f487b71bc92c4b410.svg";